import pulse from '@finn-no/pulse-sdk';
import { TrackerData } from '@finn-no/pulse-sdk/dist/types';
import { Pagination as PaginationComponent } from '@warp-ds/react';
import React from 'react';

type PaginationProps = {
    currentPage: number;
    setCurrentPage: (page: number) => void;
    totalPages: number;
};

function Pagination(props: PaginationProps) {
    const { currentPage, totalPages = 0, setCurrentPage } = props;

    const handlePageChange = React.useCallback(
        (page: number) => {
            const pulsePayload: TrackerData = {
                object: {
                    type: 'Listing',
                    layout: 'List',
                    pageNumber: page,
                },
            };
            pulse.trackPageView(pulsePayload);
            setCurrentPage(page);
        },
        [setCurrentPage],
    );

    if (!totalPages || totalPages <= 1) {
        return null;
    }

    return (
        <PaginationComponent
            className="pt-8 pb-4"
            createHref={() => '#'}
            currentPage={currentPage}
            lastPage={totalPages}
            onChange={handlePageChange}
        />
    );
}

export default Pagination;
